export class ValidationResult {
  isValid: boolean = false;
  validationMessage: string | undefined = undefined;

  constructor(isValid: boolean, validationMessage?: string) {
    this.isValid = isValid;
    this.validationMessage = validationMessage;
  }
}

export const ValidateEmail = (email?: string): ValidationResult => {
  if (!email || email.trim() === '') {
    return new ValidationResult(false, "Email є обов'язковим.");
  }
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailRegex.test(email)) {
    return new ValidationResult(false, 'Введіть коректний email.');
  }
  return new ValidationResult(true);
};

export const ValidatePassword = (password?: string): ValidationResult => {
  if (!password || password.length < 8) {
    return new ValidationResult(false, 'Пароль має містити щонайменше 8 символів.');
  }
  return new ValidationResult(true);
};

export const ValidateConfirmPassword = (password: string, confirmPassword?: string): ValidationResult => {
  if (!confirmPassword) {
    return new ValidationResult(false, "Підтвердження пароля є обов'язковим.");
  }
  if (password !== confirmPassword) {
    return new ValidationResult(false, 'Паролі не співпадають.');
  }
  return new ValidationResult(true);
};

export const ValidatePhone = (phone?: string): ValidationResult => {
  if (!phone) {
    return new ValidationResult(false, "Телефон є обов'язковим.");
  }
  const phoneRegex = /^\+?[0-9]{9,13}$/;
  if (!phoneRegex.test(phone.trim())) {
    return new ValidationResult(false, 'Введіть коректний телефон, наприклад +380671234567.');
  }
  return new ValidationResult(true);
};

// Ukrainian noun agreement: pluralUk(3, ['оренда', 'оренди', 'оренд']) -> 'оренди'.
export const pluralUk = (count: number, [one, few, many]: [string, string, string]) => {
  const lastTwo = Math.abs(count) % 100;
  const last = lastTwo % 10;
  if (lastTwo >= 11 && lastTwo <= 14) return many;
  if (last === 1) return one;
  if (last >= 2 && last <= 4) return few;
  return many;
};

export const rentalCountText = (count: number) =>
  `${count} ${pluralUk(count, ['оренда', 'оренди', 'оренд'])}`;

export const ValidateRequired =(value?: string): ValidationResult => {
  if (!value || value.trim() === '') {
    return new ValidationResult(false, "Це поле є обов'язковим.");
  }
  return new ValidationResult(true);
};
